import { updateKeyInStore } from 'App';
import { RelationshipOptions } from 'app/features/profile/personalDetails/editPersonalDetails/dependentStep';
import { store } from 'app/redux/store';
import * as Yup from 'yup';
import {
  DependentsStateValues,
  TDependentsChildrenRow,
  updateFieldArrayKey,
  updateKey,
} from './slice';

export const fields: IBaseField<
  keyof DependentsStateValues | keyof TDependentsChildrenRow
>[] = [
  {
    type: 'fieldArray',
    label: 'Dependents List',
    name: 'dependentsChildren',
    effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
    dependencies: [
      {
        name: 'firstName',
        type: 'text',
        placeholder: 'First Name',
        label: 'First Name',
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'lastName',
        type: 'text',
        placeholder: 'Last Name',
        label: 'Last Name',
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'relationship',
        type: 'select',
        label: 'Relationship',
        placeholder: 'Relationship',
        options: RelationshipOptions,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'dateOfBirth',
        type: 'date',
        placeholder: 'Last Name',
        label: 'Date of Birth',
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'SSN',
        type: 'maskedInput',
        label: 'SSN',
        mask: '999-99-9999',
        effect: updateKeyInStore(updateKey),
      },
    ],
    defaultDependency: {
      firstName: null,
      lastName: null,
      dateOfBirth: null,
      SSN: null,
    },
  },
  {
    type: 'upload',
    name: 'documentShowSameAddress',
    label:
      'Upload document showing you & the dependent share the same address?',
    subLabel: () => (
      <div>
        <p>
          To show both you and your child lived together at the same address or
          addresses for more than half of 2019, send either:
        </p>
        <ul>
          <li>School, medical, daycare, or social service records.</li>
          <li>
            A letter on the official letterhead from a school, medical provider,
            social service agency,
          </li>
        </ul>
        <p>
          or place of worship that shows names, common address and dates. (If
          you send a letter from a relative who provides your daycare, you MUST
          send at least one additional letter that provides proof.)
        </p>
        <p>
          <b>You may need to send more than one document</b> to show that the
          child lived with you for more than half of the year.
        </p>
      </div>
    ),
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    type: 'upload',
    name: 'provideHouseholdExpenses',
    label: 'Do you provide over 50% of the household expenses?',
    subLabel: () => (
      <div>
        <ul>
          <li>A statement of account from a child support agency.</li>
          <li>
            A statement from any government agency verifying the amount and type
            of benefits you and/or your dependent received for the year.
          </li>
          <li>
            Rental agreements or a statement showing the fair rental value of
            your residence (proof of lodging cost).
          </li>
          <li>
            Utility and repair bills (proof of household expenses) with canceled
            checks or receipts.
          </li>
          <li>
            Daycare, school, medical records or bills (proof of child's support)
            with canceled checks or receipts.
          </li>
          <li>
            Clothing bills (proof of child's support) with canceled checks or
            receipts.
          </li>
        </ul>
      </div>
    ),
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    // DEPENDS ON THE SELECTION OF HAVE SPOUSE
    type: 'select',
    name: 'whoClaimDependents',
    label: 'As you are not filing jointly - who will claim the dependents?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn: 'prepareQuestionnaire.spouse',
    predicate: (value) => value === 'no',
    options: [
      { label: 'Myself', value: 'Myself' },
      { label: 'Spouse', value: 'Spouse' },
      { label: 'Split', value: 'Split' },
    ],
  },
];

export const validationSchema = Yup.object().shape({
  dependentsChildren: Yup.array(
    Yup.object({
      firstName: Yup.string().nullable().trim().required('required'),
      lastName: Yup.string().nullable().trim().required('required'),
      relationship: Yup.string().nullable().trim().required('required'),
      SSN: Yup.string().trim().nullable().required('required'),
      dateOfBirth: Yup.string().trim().nullable().required('required'),
    }),
  ),
});
